const steps = [
  {
    emoji: "🦆",
    step: "01",
    title: "Grab a Duck",
    description:
      "Pick up a small rubber duck — any color, any style. You can find them at dollar stores, party supply shops, or order a fun pack online. The sillier, the better!",
    color: "bg-yellow-50 border-yellow-200",
    accent: "text-yellow-500",
  },
  {
    emoji: "📍",
    step: "02",
    title: "Hide It Somewhere Fun",
    description:
      "Leave your duck in a public spot around Gwinnett County — a park bench, library shelf, playground, coffee shop windowsill, or anywhere a stranger might smile when they find it.",
    color: "bg-pink-50 border-pink-200",
    accent: "text-pink-500",
  },
  {
    emoji: "📸",
    step: "03",
    title: "Snap a Photo",
    description:
      "If you find a duck, snap a photo! Capture the moment — the duck, the location, your reaction. Every find is a little story worth sharing.",
    color: "bg-orange-50 border-orange-200",
    accent: "text-orange-500",
  },
  {
    emoji: "#️⃣",
    step: "04",
    title: "Share & Tag",
    description:
      "Post your duck find on social media using <strong>#WhatTheDuck</strong> and tag <strong>@TheMommyMingle</strong>. Then submit your photo here so we can add it to our community gallery!",
    color: "bg-rose-50 border-rose-200",
    accent: "text-rose-500",
  },
  {
    emoji: "🔄",
    step: "05",
    title: "Keep It Going",
    description:
      "Found a duck? You can keep it as a keepsake OR re-hide it somewhere new to keep the kindness chain going. Pass the joy forward, mama!",
    color: "bg-amber-50 border-amber-200",
    accent: "text-amber-500",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 bg-white" id="how-it-works">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block bg-yellow-100 text-yellow-700 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            How It Works
          </span>
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Join the Duck Hunt 🦆
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            It's simple, it's silly, and it's exactly the kind of joy moms need. Here's how to play along.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((s) => (
            <div
              key={s.step}
              className={`relative border rounded-2xl p-7 ${s.color} transition-transform hover:-translate-y-1 duration-200`}
            >
              <div className={`text-3xl mb-3`}>{s.emoji}</div>
              <div className={`text-xs font-bold uppercase tracking-widest mb-2 ${s.accent}`}>
                Step {s.step}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{s.title}</h3>
              <p
                className="text-gray-600 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: s.description }}
              />
            </div>
          ))}

          {/* CTA card */}
          <div className="border border-pink-300 rounded-2xl p-7 bg-gradient-to-br from-pink-500 to-rose-500 text-white flex flex-col justify-center items-center text-center">
            <div className="text-4xl mb-3">💛</div>
            <h3 className="text-lg font-bold mb-2">Why We Do This</h3>
            <p className="text-sm text-white/90 leading-relaxed">
              Motherhood is beautiful AND chaotic. Sometimes you just need a little unexpected joy. That's what #WhatTheDuck is all about — spreading smiles, one tiny duck at a time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
